import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const PerformanceInsightsPage: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-confluencePerformanceInsightsPage" */ '../src/PerformanceInsightsPage.tsx'
			)
		).PerformanceInsightsPage,
});
